import * as React from 'react';
import axios, { AxiosResponse } from 'axios';
import config from '../../config';
import { connect } from 'react-redux';

import { toast } from 'react-toastify';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IState {
    isLoading: boolean,
    likes: number,
    dislikes: number
}

interface IProps extends WithTranslation {
    media_id: number,
    isShowBusiness?: boolean,
    t: any
}

class Favorite extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: true,
            likes: 0,
            dislikes: 0
        };
    }

    async componentDidMount() {
        try {
            let response: AxiosResponse = await axios.get(`${config.host}/auth/rating?media_id=${this.props.media_id}`);

            if (!this._isUnmounted) {
                this.setState({
                    likes: response.data.likes,
                    dislikes: response.data.dislikes,
                    isLoading: false
                });
            }
        } catch (err) {

        }
    }

    clickHandler(act: string) {
        let formData = new FormData();

        formData.append("act", act);
        formData.append("modelId", "0");
        formData.append("targetId", `${this.props.media_id}`);

        axios.post(`${config.host}/auth/vote`, formData).then((response: AxiosResponse) => {
            let {data} = response;
            toast(this.props.t(data.content));

            if (data.success && data.success === true && data.changed && data.changed === true) {
                if (act == "like") {
                    this.setState({
                        likes: this.state.likes + 1,
                        dislikes: this.state.dislikes - 1
                    })
                } else {
                    this.setState({
                        dislikes: this.state.dislikes + 1,
                        likes: this.state.likes - 1
                    });
                }
            }
        });
    }

    render() {
        return (
            <div className={!this.props.isShowBusiness ? "text-center div-v vote-box" : "text-center div-v"} id="vote-0-22545" data-placement="top" data-container="body" data-toggle="popover">
                <span onClick={() => {
                    this.clickHandler("like");
                }} className="btn btn-success glyphicon glyphicon-thumbs-up">{this.state.likes}</span>
                &nbsp;
                <span onClick={() => {
                    this.clickHandler("dislike");
                }} className="btn btn-danger glyphicon glyphicon-thumbs-down">{this.state.dislikes}</span>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps)(withTranslation()(Favorite));
